module.exports = __webpack_public_path__ + "img/blood_pressure_black.1edd4b5f.svg";